import {
  OreButton,
  OreHeading,
  OreModal,
  OreModalBox,
  OreModalBoxBody,
  OreModalBoxFooter,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { Dispatch, SetStateAction, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AccessRolesModel } from '@/AccessRoles/domain'
import { formTranslation } from '@/Shared/ui/sharedTranslation'
import { useUserData } from '@/User/ui/context'
import { userDataTranslation } from '@/User/ui/userTranslation'
import { GroupType } from '@/partnersGroups/domain/ProfileTypes'

import { accessRolesTranslation } from '../AccesRolesTranslation'

interface Props {
  isOpen: boolean
  setOpenResend: Dispatch<SetStateAction<boolean>>
  profile: AccessRolesModel
  setRefresh: Dispatch<SetStateAction<number>>
}

export const AccessRolesResendWelcomeEmailSendModal = ({
  isOpen,
  setOpenResend,
  profile,
  setRefresh,
}: Props): JSX.Element => {
  const { resendWelcomeEmail } = useUserData()
  const { t } = useTranslation()

  const fullName = `${profile.name} ${profile.surname} ${profile.surname2}`

  return (
    <OreModal open={isOpen} handleOnClose={() => setOpenResend(false)}>
      <OreModalBox closeIcon={false}>
        <OreModalBoxBody>
          <OreHeading size="headline-lg">
            {t(accessRolesTranslation.modal.resendWelcomeEmail.title)}
          </OreHeading>
          <OreStack space="medium">
            <OreText>
              {t(accessRolesTranslation.modal.resendWelcomeEmail.description)}
            </OreText>
            <OreStack space="medium" direction="column">
              <OreStack space="2xsmall" direction="column">
                <OreText>{t(accessRolesTranslation.modal.nameAndSurnames)}</OreText>
                <OreText bold>{fullName}</OreText>
              </OreStack>
              <OreStack space="2xsmall" direction="column">
                <OreText>{t(userDataTranslation.email.label)}</OreText>
                <OreText bold>{profile.email}</OreText>
              </OreStack>
            </OreStack>
          </OreStack>
        </OreModalBoxBody>
        <OreModalBoxFooter>
          <OreStack direction="row" space="medium" placeContent="end">
            <OreButton
              as="button"
              category="secondary"
              size="small"
              onClick={() => setOpenResend(false)}
            >
              {t(accessRolesTranslation.modal.delete.cancel)}
            </OreButton>
            <OreButton
              as="button"
              category="primary"
              size="small"
              onClick={() =>
                resendWelcomeEmail(profile.userName).then(() => {
                  setOpenResend(false)
                  setRefresh(r => r + 1)
                })
              }
            >
              {t(formTranslation.common.buttons.send)}
            </OreButton>
          </OreStack>
        </OreModalBoxFooter>
      </OreModalBox>
    </OreModal>
  )
}
